import React, { useEffect, useState } from 'react';
import { Grid, Paper, Icon, TextField } from '@mui/material';
import { Container, Button, Row, Col, Table, Form, Spinner } from 'react-bootstrap';
import { makeStyles } from '@material-ui/core/styles';
import { PieChart, Pie, Sector, Cell, Label } from 'recharts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf, faList, faFileVideo, faClipboard } from '@fortawesome/free-solid-svg-icons';
import EditNoteIcon from '@mui/icons-material/EditNote';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import GetAppIcon from '@mui/icons-material/GetApp';
import DeleteIcon from '@mui/icons-material/Delete';
import { Autocomplete } from '@mui/material';
import { DateRangePicker } from '@mui/lab';
import html2canvas from 'html2canvas';
import { jsPDF } from "jspdf";
import { DatePicker, LocalizationProvider } from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { BarChart, Bar, Rectangle, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        padding: theme.spacing(2),
    },
    paper: {
        textAlign: 'center',
        color: theme.palette.text.secondary,
        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)', // Adding shadow
    },
}));

const GeneralQuizMasterFragment = () => {
    const classes = useStyles();
    const [formData, setFormData] = useState({
        name: '',
        passing: 80,
        questionNo: 10,
        thumbnail: null,
        shuffle: 'yes',
        questions: [{
            question: '',
            options: [...Array(4)],
            correctAnswer: 0,
            questionType: 'MCQ',
            category: ''
        }],
        createdBy: localStorage.getItem('userId')
    });
    const [quiz, setQuiz] = useState([]);
    const [graphData, setGraphData] = useState([]);
    const [categoryQuiz, setCategoryQuiz] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [isEdit, setIsEdit] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedCategories, setSelectedCategories] = useState([]);

    useEffect(() => {
        fetchCategoryQuiz();
    }, []);

    useEffect(() => {
        fetchQuiz(currentPage);
    }, [currentPage]); // Add formData.company to the dependencies

    const handleFileChange = (e) => {
        setFormData({ ...formData, thumbnail: e.target.files[0] });
    };

    const fetchCategoryQuiz = async () => {
        try {
            const myHeaders = new Headers();
            myHeaders.append("Authorization", localStorage.getItem('token'));
            const requestOptions = {
                method: "GET",
                headers: myHeaders,
                redirect: "follow"
            };
            fetch("https://beiguru.co.in/categoryQuiz", requestOptions)
                .then((response) => {
                    if (response.status == 401) {
                        localStorage.clear();
                        window.location.reload();
                        return [];
                    } else {
                        return response.json()
                    }
                }).then((result) => {
                    setCategoryQuiz(result);
                })
                .catch((error) => console.error(error));
        } catch (error) {
            console.error(error);
        }
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const fetchQuiz = async (currentPage) => {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", localStorage.getItem('token'));
        const requestOptions = {
            method: "GET",
            headers: myHeaders,
            redirect: "follow"
        };
        let apiUrl = `https://beiguru.co.in/admin/general-quiz-master`;
        fetch(apiUrl, requestOptions)
            .then((response) => {
                if (response.status == 401) {
                    localStorage.clear();
                    window.location.reload();
                    return [];
                } else {
                    return response.json()
                }
            })
            .then((result) => {
                setQuiz(result);
            })
            .catch((error) => console.error(error));
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const fileName = formData.thumbnail.name;
            const isPngOrJpg = /\.(png|jpg)$/i.test(fileName);

            if (isPngOrJpg) {
                setIsLoading(true);
                const myHeaders = new Headers();
                myHeaders.append("Authorization", localStorage.getItem('token'));
                const formdata = new FormData();
                formdata.append("name", formData.name);
                formdata.append("passing", formData.passing);
                formdata.append("shuffle", formData.shuffle == 'yes');
                formdata.append("questionNo", formData.questionNo);
                formdata.append("thumbnail", formData.thumbnail, formData.thumbnail.name);
                formdata.append("questions", JSON.stringify(formData.questions.map(question => ({
                    question: question.question,
                    options: question.options,
                    category: question.category,
                    correctAnswer: question.questionType == 'single' ? question.correctAnswer.toString().replace('[', '').replace(']', '') : question.options[question.correctAnswer],
                    isMCQ: question.questionType === 'MCQ'
                }))));
                formdata.append("createdBy", formData.createdBy);
                const requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    body: formdata,
                    redirect: "follow"
                };
                try {
                    const quizResponse = await fetch(`https://beiguru.co.in/admin/general-quiz-master`, requestOptions);

                    if (!quizResponse.ok) {
                        throw new Error('Failed to create quiz');
                    }

                    setFormData({
                        name: '',
                        passing: 80,
                        questionNo: 10,
                        thumbnail: null,
                        questions: [],
                        createdBy: localStorage.getItem('userId')
                    });
                    alert('Quiz master created successfully');
                    // Handle success
                } catch (error) {
                    console.error('Error creating quiz:', error.message);
                    alert('Error creating quiz master, please try again!');
                    // Handle error
                }
                fetchQuiz();
                setIsLoading(false);
            } else {
                alert('Thumbnail can only contain png or jpg.');
            }
        } catch (error) {
            alert('Failed to create quiz master, please try again!!');
            setIsLoading(false);
        }
    };

    const handleEdit = async (material) => {

        setFormData({
            name: material.name,
            passing: material.passing,
            shuffle: material.shuffle ? 'yes' : 'no',
            questionNo: material.questionNo,
            questions: material.questions.map(question => ({
                question: question.question,
                options: question.options,
                category: question.category._id,
                correctAnswer: question.isMCQ
                    ? question.options.indexOf(question.correctAnswer)
                    : question.correctAnswer ? question.correctAnswer.includes(',')
                        ? question.correctAnswer.split(',').map(numString => parseInt(numString, 10)) : ''
                        : '',
                questionType: question.isMCQ ? 'MCQ' : 'single',
            })),
            createdBy: localStorage.getItem('userId'),
            quizID: material._id,
        });
        setIsEdit(true);
    }

    const handleModify = async (e) => {
        e.preventDefault();
        try {
            setIsLoading(true);
            const myHeaders = new Headers();
            myHeaders.append("Authorization", localStorage.getItem('token'));
            const formdata = new FormData();
            formdata.append("name", formData.name);
            formdata.append("passing", formData.passing);
            formdata.append("shuffle", formData.shuffle == 'yes');
            formdata.append("questionNo", formData.questionNo);
            if (formData.thumbnail) {
                formdata.append("thumbnail", formData.thumbnail, formData.thumbnail.name);
            }
            formdata.append("questions", JSON.stringify(formData.questions.map(question => ({
                question: question.question,
                options: question.options,
                category: question.category,
                correctAnswer: question.questionType == 'single' ? question.correctAnswer.toString().replace('[', '').replace(']', '') : question.options[question.correctAnswer],
                isMCQ: question.questionType === 'MCQ'
            }))));
            formdata.append("createdBy", formData.createdBy);
            const requestOptions = {
                method: "PUT",
                headers: myHeaders,
                body: formdata,
                redirect: "follow"
            };
            try {
                const surveyResponse = await fetch(`https://beiguru.co.in/admin/general-quiz-master/${formData.quizID}`, requestOptions);

                if (!surveyResponse.ok) {
                    alert('Error updating quiz master, please try again!');
                    throw new Error('Failed to create quiz master');
                }

                alert('Quiz master updated successfully');
                setFormData({
                    name: '',
                    passing: 80,
                    questionNo: 10,
                    thumbnail: null,
                    shuffle: 'yes',
                    questions: [],
                    createdBy: localStorage.getItem('userId')
                });

            } catch (error) {
                alert('Error updating quiz master, please try again!');
                console.error('Error creating quiz master:', error.message);
                // Handle error
            }
            fetchQuiz();
            setIsEdit(false);
            setIsLoading(false);
        } catch (error) {
            alert('Error updating quiz master, please try again!');
            setIsLoading(false);
        }
    }

    const handleDelete = (courseID) => {
        // Display confirmation popup before deleting
        const isConfirmed = window.confirm("Are you sure you want to delete this quiz master?");
        if (!isConfirmed) return; // If user cancels, do nothing

        const myHeaders = new Headers();
        myHeaders.append("Authorization", localStorage.getItem('token'));
        const requestOptions = {
            method: "DELETE",
            headers: myHeaders,
            redirect: "follow"
        };
        fetch(`https://beiguru.co.in/admin/general-quiz-master/${courseID}`, requestOptions)
            .then((result) => {
                if (result.ok) {
                    alert('Quiz master deleted successfully');
                    fetchQuiz();
                }
            }).catch((error) => console.error(error));
    }

    const filteredData = selectedCategories.length > 0
        ? graphData.filter(item =>
            selectedCategories.some(category => category._id === item.categoryId))
        : graphData;
    const averageScore = filteredData.map(category => category.Current).reduce((acc, cur, _, arr) => acc + cur / arr.length, 0);

    return (<Grid item xs={10} style={{ padding: '20px', height: '100%', fontFamily: "Noto Sans", fontWeight: '500', justifyContent: 'center', alignContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
        <Container fluid style={{ height: '100%' }}>
            <Row>
                <Col xs={12} style={{ flex: 1, height: '90vh', width: '100%', display: 'flex', alignItems: 'center', flexDirection: 'column', justifyContent: 'space-between' }}>
                    <div style={{ width: '100%' }}>
                        {quiz.length > 0 ? <Table striped bordered hover >
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Total Questions</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {/* Map through companies data to display each company */}
                                {quiz.map(material => {
                                    return <tr key={material._id}>
                                        <td>
                                            {material.name}
                                            <p style={{ margin: '0px', padding: '0px', fontSize: '10px' }}>{material._id}</p>
                                        </td>
                                        <td>{material.questions.length}</td>
                                        <td>
                                            <EditNoteIcon onClick={() => handleEdit(material)} style={{ color: 'green', cursor: 'pointer' }} />
                                            <DeleteSweepIcon onClick={() => handleDelete(material._id)} style={{ color: 'red', cursor: 'pointer' }} />
                                            {/* <GetAppIcon onClick={() => handleDownloadAnswers(material._id)} style={{ color: 'blue', cursor: 'pointer' }} /> */}
                                        </td>
                                    </tr>
                                })}
                            </tbody>
                        </Table> : <div style={{ margin: '20px', textAlign: 'center' }}>No quiz found, please try again!</div>}
                    </div>
                    <div style={{ flex: 1 }} />
                    <nav aria-label="Courses pagination">
                        <ul className="pagination">
                            {[...Array(totalPages).keys()].map((page) => (
                                <li key={page} className={`page-item ${currentPage === page + 1 ? 'active' : ''}`}>
                                    <button className="page-link" onClick={() => handlePageChange(page + 1)}>
                                        {page + 1}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </nav>
                </Col>
                <Col xs={4} style={{ height: '82vh', overflowY: 'auto' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                        <h4>{isEdit ? 'Edit' : 'Create'} Quiz</h4>
                        <Button variant="secondary" onClick={() => {
                            setFormData({
                                name: '',
                                passing: 80,
                                questionNo: 10,
                                thumbnail: null,
                                shuffle: 'yes',
                                questions: [],
                                createdBy: localStorage.getItem('userId')
                            });
                            setIsEdit(false);
                        }}>Cancel</Button>
                    </div>
                    <Form.Group controlId={`formsurveyname`} style={{ marginBottom: '10px' }}>
                        <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Quiz Name</Form.Label>
                        <Form.Control
                            className="w-100"
                            style={{ width: '100%', borderRadius: '5px' }}
                            type="text"
                            placeholder="Enter the quiz name"
                            value={formData.name}
                            onChange={(e) => {
                                setFormData({ ...formData, name: e.target.value });
                            }}
                        />
                    </Form.Group>
                    <div style={{ height: '10px' }} />
                    <Form.Group>
                        <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Passing Percentage</Form.Label>
                        <Form.Control
                            className="w-100"
                            style={{ width: '100%', borderRadius: '20px' }}
                            type="number"
                            value={formData.passing}
                            onChange={(e) => setFormData({ ...formData, passing: e.target.value })}
                        />
                    </Form.Group>

                    <div style={{ height: '10px' }} />
                    <Form.Group>
                        <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>No of Question for Quiz</Form.Label>
                        <Form.Control
                            className="w-100"
                            style={{ width: '100%', borderRadius: '20px' }}
                            type="number"
                            value={formData.questionNo}
                            onChange={(e) => setFormData({ ...formData, questionNo: e.target.value })}
                        />
                    </Form.Group>
                    <Form>
                        <Form.Group>
                            <Form.Label>Shuffle</Form.Label>
                            <div style={{ flexDirection: 'row', display: 'flex' }}>
                                <Form.Check
                                    type="radio"
                                    label="Yes"
                                    name="yesNoOptions"
                                    value="yes"
                                    checked={formData.shuffle === 'yes'}
                                    onChange={(e) => setFormData({ ...formData, shuffle: 'yes' })}
                                    id="yesOption"
                                />
                                <div style={{ width: '20px' }} />
                                <Form.Check
                                    type="radio"
                                    label="No"
                                    name="yesNoOptions"
                                    value="no"
                                    checked={formData.shuffle === 'no'}
                                    onChange={(e) => setFormData({ ...formData, shuffle: 'no' })}
                                    id="noOption"
                                />
                            </div>
                        </Form.Group>
                    </Form>
                    <div style={{ height: '10px' }} />
                    {/* <Form.Group>
                        <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Weightage</Form.Label>
                        <Form.Control
                            className="w-100"
                            style={{ width: '100%', borderRadius: '20px' }}
                            type="number"
                            value={formData.shuffle}
                            onChange={(e) => setFormData({ ...formData, dueDate: e.target.value })}
                        />
                    </Form.Group> */}
                    {isLoading ? null : <Form.Group controlId="formCompanyLogo">
                        <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Upload Thumbnail</Form.Label>
                        <Form.Control type="file" className="w-100"
                            placeholder="Select Thumbnail"
                            accept=".png,.jpg,.jpeg"
                            onChange={handleFileChange}
                            style={{ width: '100%', borderRadius: '20px' }} />
                    </Form.Group>}
                    <div style={{ height: '10px' }} />
                    {formData.questions.map((question, questionIndex) => (
                        <div key={questionIndex} style={{ backgroundColor: '#F6F6F6', marginBottom: '10px', padding: '10px', borderRadius: '5px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'row', alignItems: 'center' }}>
                                <h5 style={{ fontWeight: '500', borderRadius: '20px', alignSelf: 'center' }}>Question {questionIndex + 1}</h5>
                                <DeleteSweepIcon onClick={() => {
                                    const newQuestions = [...formData.questions];
                                    newQuestions.splice(questionIndex, 1); // Remove question
                                    setFormData({ ...formData, questions: newQuestions });
                                }} style={{ color: 'red', cursor: 'pointer' }} />
                            </div>
                            <Form.Group controlId={`formCategory${questionIndex}`}>
                                <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Category</Form.Label>
                                <Form.Control
                                    className="w-100"
                                    style={{ width: '100%', borderRadius: '20px' }}
                                    as="select"
                                    value={question.category}
                                    onChange={(e) => {
                                        const newQuestions = [...formData.questions];
                                        newQuestions[questionIndex].category = e.target.value;
                                        setFormData({ ...formData, questions: newQuestions });
                                    }}>
                                    <option value="">Select a category</option>
                                    {categoryQuiz.map(category => (
                                        <option key={category._id} value={category._id}>{category.name}</option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                            <Form.Group controlId={`formQuestionType${questionIndex}`}>
                                <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center', marginTop: '10px', marginBottom: '10px' }}>
                                    <Form.Label style={{ fontWeight: '500', borderRadius: '20px', margin: '0px', padding: '0px' }}>Question Type:</Form.Label>
                                    <div style={{ width: '10px' }} />
                                    <Form.Check
                                        type="radio"
                                        label="MCQ"
                                        checked={question.questionType === 'MCQ'}
                                        onChange={(e) => {
                                            const newQuestions = [...formData.questions];
                                            newQuestions[questionIndex].questionType = 'MCQ';
                                            newQuestions[questionIndex].correctAnswer = 0;
                                            newQuestions[questionIndex].options = [...Array(4)]
                                            setFormData({ ...formData, questions: newQuestions });
                                        }}
                                    />
                                    <div style={{ width: '10px' }} />
                                    <Form.Check
                                        type="radio"
                                        label="Single"
                                        checked={question.questionType === 'single'}
                                        onChange={(e) => {
                                            const newQuestions = [...formData.questions];
                                            newQuestions[questionIndex].questionType = 'single';
                                            newQuestions[questionIndex].correctAnswer = [];
                                            newQuestions[questionIndex].options = [...Array(4)]
                                            setFormData({ ...formData, questions: newQuestions });
                                        }}
                                    />
                                </div>
                            </Form.Group>
                            {question.questionType === 'MCQ' && (
                                <div>
                                    <Form.Group controlId="formQuestion">
                                        <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Question</Form.Label>
                                        <Form.Control
                                            className="w-100"
                                            style={{ width: '100%', borderRadius: '20px' }}
                                            type="text"
                                            as="textarea" rows={2}
                                            placeholder="Enter the question"
                                            value={question.question}
                                            onChange={(e) => {
                                                const newQuestions = [...formData.questions];
                                                newQuestions[questionIndex].question = e.target.value;
                                                setFormData({ ...formData, questions: newQuestions });
                                            }}
                                        />
                                    </Form.Group>
                                    {/* Options */}
                                    <Form.Group controlId={`formOptions${questionIndex}`}>
                                        <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Options</Form.Label>
                                        {question.options.map((option, index) => (
                                            <div key={index} className="mb-3" style={{ flexDirection: 'row', display: 'flex', alignItems: 'center' }}>
                                                <Form.Check
                                                    type="radio"
                                                    id={`option${index}`}
                                                    name={`correctAnswer${questionIndex}`}
                                                    value={index}
                                                    checked={question.correctAnswer === index}
                                                    onChange={(e) => {
                                                        const newQuestions = [...formData.questions];
                                                        newQuestions[questionIndex].correctAnswer = index;
                                                        setFormData({ ...formData, questions: newQuestions });
                                                    }}
                                                />
                                                <div style={{ width: '10px' }} />
                                                <Form.Control
                                                    className="w-100"
                                                    style={{ width: '100%', borderRadius: '20px' }}
                                                    type="text"
                                                    value={option}
                                                    placeholder={`Option ${index + 1}`}
                                                    onChange={(e) => {
                                                        const newQuestions = [...formData.questions];
                                                        const newOptions = [...question.options];
                                                        newOptions[index] = e.target.value;
                                                        newQuestions[questionIndex].options = newOptions;
                                                        setFormData({ ...formData, questions: newQuestions });
                                                    }}
                                                />
                                            </div>
                                        ))}
                                    </Form.Group>
                                </div>
                            )}
                            {question.questionType === 'single' && (<div>
                                <Form.Group controlId="formQuestion">
                                    <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Question</Form.Label>
                                    <Form.Control
                                        className="w-100"
                                        style={{ width: '100%', borderRadius: '20px' }}
                                        type="text"
                                        as="textarea" rows={2}
                                        placeholder="Enter the question"
                                        value={question.question}
                                        onChange={(e) => {
                                            const newQuestions = [...formData.questions];
                                            newQuestions[questionIndex].question = e.target.value;
                                            setFormData({ ...formData, questions: newQuestions });
                                        }}
                                    />
                                </Form.Group>
                                {/* Options */}
                                <Form.Group controlId={`formOptions${questionIndex}`}>
                                    <Form.Label style={{ fontWeight: '500', borderRadius: '20px' }}>Options</Form.Label>
                                    {question.options.map((option, index) => (
                                        <div key={index} className="mb-3" style={{ flexDirection: 'row', display: 'flex', alignItems: 'center' }}>
                                            <Form.Check
                                                type="checkbox" // Change type to "checkbox"
                                                id={`option${index}`}
                                                name={`correctAnswer${questionIndex}`}
                                                value={index}
                                                checked={question.correctAnswer.includes(index)} // Check if the index is included in correctAnswer array
                                                onChange={() => {
                                                    const newQuestions = [...formData.questions];
                                                    const newCorrectAnswer = question.correctAnswer.includes(index)
                                                        ? question.correctAnswer.filter(item => item !== index)
                                                        : [...newQuestions[questionIndex].correctAnswer, index];
                                                    newQuestions[questionIndex].correctAnswer = newCorrectAnswer;
                                                    setFormData({ ...formData, questions: newQuestions });
                                                }}
                                            />
                                            <div style={{ width: '10px' }} />
                                            <Form.Control
                                                className="w-100"
                                                style={{ width: '100%', borderRadius: '20px' }}
                                                type="text"
                                                placeholder={`Option ${index + 1}`}
                                                value={option}
                                                onChange={(e) => {
                                                    const newQuestions = [...formData.questions];
                                                    const newOptions = [...question.options];
                                                    newOptions[index] = e.target.value;
                                                    newQuestions[questionIndex].options = newOptions;
                                                    setFormData({ ...formData, questions: newQuestions });
                                                }}
                                            />
                                        </div>
                                    ))}
                                </Form.Group>
                            </div>
                            )}
                        </div>
                    ))}
                    {/* Add question button */}
                    <Button
                        variant="outline-primary"
                        size="sm"
                        elevation={3}
                        className="w-100"
                        style={{ fontWeight: '600', borderRadius: '20px', marginBottom: '10px' }}
                        onClick={() => {
                            setFormData(prevState => ({
                                ...prevState,
                                questions: [...prevState.questions, { question: '', options: [{ optionText: '', weightage: '' }] }]
                            }));
                        }}
                    >
                        Add Question
                    </Button>
                    <Button
                        onClick={isEdit ? handleModify : handleSubmit}
                        style={{ fontWeight: '600', borderRadius: '20px', marginTop: '5px' }}
                        elevation={3}
                        className="w-100"
                        variant="primary"
                        type="submit"
                        disabled={isLoading}
                    >
                        {isLoading ? (
                            <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            />
                        ) : null}
                        {isEdit ? 'Modify' : 'Create'} Quiz
                    </Button>
                </Col>
            </Row>
        </Container>
    </Grid >
    );
}

export default GeneralQuizMasterFragment;